import type { FunctionComponent } from 'react';
import React from 'react';

import ReturnsAndExchangesUPSPickUpAddress from './Returns/ReturnsAndExchangesUPSPickUpAddress';

import { cn } from 'helpers/classnames';
import useMartyContext from 'hooks/useMartyContext';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import styles from 'styles/components/account/pickUpReturnDetails.scss';

interface PickUpReturnDetailsProps {
  UPSPickUpAddress: {
    addressLine1: string;
    addressLine2: string;
    districtOrCounty: string;
    city: string;
    stateOrRegion: string;
    postalCode: string;
    countryName: string;
    fullName: string;
  };
  className: string;
}

export const PickUpReturnDetails: FunctionComponent<PickUpReturnDetailsProps> = ({ UPSPickUpAddress, className }) => {
  const { testId } = useMartyContext();

  return (
    <div className={cn(styles.instructionsContainer, className)}>
      <ReturnsAndExchangesUPSPickUpAddress UPSPickUpAddress={UPSPickUpAddress} />
      <div className={styles.instructionsColumn}>
        <h3 className={styles.columnTitle} data-test-id={testId('instructionsColumnTitle')}>
          UPS Pick-up Instructions:
        </h3>
        <p>UPS requests that someone is present at the time of pick up.</p>
        <p className={styles.secondLine}>
          If you choose to leave your package outside your door instead, please attach a note with "For UPS to Zappos" on the package. Please
          understand there is no guarantee the UPS driver will pick up an unattended package. If you have any questions, you can contact us here (
          <a href="http://www.zappos.com/c/contact-us">http://www.zappos.com/c/contact-us</a>) 24/7.
        </p>
      </div>
    </div>
  );
};

PickUpReturnDetails.displayName = 'PickUpReturnDetails';

export default withErrorBoundary(PickUpReturnDetails.displayName, PickUpReturnDetails);
